/* Kop: wisselende USP-balk en korte voorbeeldtekst tot 1000 px, en op elke breedte een kop die wegschuift bij omlaag
   scrollen en terugkomt bij omhoog scrollen. */
(function () {
  'use strict';
  var smal = window.matchMedia('(max-width: 1000px)');
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var luister = function (mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); };

  function balk(el) {
    var lijst = el.querySelector('.bk-usp-lijst');
    var knop = el.querySelector('[data-bk-knop]');
    if (!lijst) return;
    var tijd = parseInt(el.getAttribute('data-bk-tijd'), 10);
    if (!(tijd >= 2000)) tijd = 5000;
    var timer = null, gestopt = false, gewild = false, zweeft = false, x0 = null;

    var items = function () {
      return Array.prototype.filter.call(lijst.children, function (li) { return getComputedStyle(li).display !== 'none'; });
    };
    var actief = function () { return lijst.querySelector('[data-stand="actief"]'); };

    function zet(nieuw, richting) {
      var oud = actief();
      if (!nieuw || nieuw === oud) return;
      nieuw.classList.add('bk-direct');
      nieuw.setAttribute('data-stand', richting < 0 ? 'links' : 'rechts');
      void nieuw.offsetWidth;
      nieuw.classList.remove('bk-direct');
      nieuw.setAttribute('data-stand', 'actief');
      if (oud) oud.setAttribute('data-stand', richting < 0 ? 'rechts' : 'links');
    }
    function stap(richting) {
      var rij = items();
      if (rij.length < 2) return;
      var i = rij.indexOf(actief());
      if (i < 0) i = 0;
      zet(rij[(i + (richting < 0 ? -1 : 1) + rij.length) % rij.length], richting);
    }
    function herstel() {
      var rij = items(), nu = actief();
      if (rij.length && rij.indexOf(nu) < 0) {
        if (nu) nu.removeAttribute('data-stand');
        rij[0].setAttribute('data-stand', 'actief');
      }
    }
    function kan() { return smal.matches && (!rustig.matches || gewild) && items().length > 1; }
    function plan() {
      clearTimeout(timer);
      timer = null;
      if (gestopt || zweeft || document.hidden || !kan()) return;
      timer = setTimeout(function () { stap(1); plan(); }, tijd);
    }
    function toonKnop() {
      if (!knop) return;
      var draait = !gestopt && kan();
      knop.hidden = !(smal.matches && items().length > 1);
      knop.textContent = draait ? 'Wisselen stoppen' : 'Wisselen starten';
      lijst.setAttribute('aria-live', draait ? 'off' : 'polite');
      el.classList.toggle('bk-stil', !draait);
    }
    function stop() { if (!gestopt) { gestopt = true; gewild = false; plan(); toonKnop(); } }
    function start() { gestopt = false; gewild = true; toonKnop(); plan(); }

    el.addEventListener('mouseenter', function () { zweeft = true; plan(); });
    el.addEventListener('mouseleave', function () { zweeft = false; plan(); });
    el.addEventListener('focusin', stop);
    el.addEventListener('pointerdown', function (e) {
      el.removeAttribute('data-bk-veeg');
      if (knop && knop.contains(e.target)) return;
      stop();
      x0 = e.clientX;
    });
    el.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 30) stap(dx < 0 ? 1 : -1);
    });
    el.addEventListener('pointercancel', function () { x0 = null; });
    // Een veeg is geen klik: een link in de balk opent dan niet.
    el.addEventListener('click', function (e) { if (el.getAttribute('data-bk-veeg') === '1') { e.preventDefault(); el.removeAttribute('data-bk-veeg'); } }, true);
    el.addEventListener('pointermove', function (e) { if (x0 !== null && Math.abs(e.clientX - x0) > 30) el.setAttribute('data-bk-veeg', '1'); });
    if (knop) {
      knop.addEventListener('click', function () { if (!gestopt && kan()) stop(); else start(); });
      knop.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); stop(); stap(e.key === 'ArrowRight' ? 1 : -1); }
      });
    }
    document.addEventListener('visibilitychange', plan);
    var wissel = function () { herstel(); toonKnop(); plan(); };
    luister(smal, wissel);
    luister(rustig, wissel);
    window.addEventListener('resize', herstel);
    herstel();
    toonKnop();
    plan();
  }

  function zoekveld() {
    var veld = document.getElementById('search_main');
    if (!veld || !veld.getAttribute('data-bk-kort')) return;
    var lang = veld.getAttribute('placeholder') || '';
    var kort = veld.getAttribute('data-bk-kort');
    var pas = function () { veld.setAttribute('placeholder', smal.matches ? kort : lang); };
    pas();
    luister(smal, pas);
  }

  // Plakkende kop: schuift weg na meer dan zijn eigen hoogte omlaag scrollen en komt terug na een derde daarvan omhoog;
  // bovenaan de pagina altijd zichtbaar. Blijft staan zolang het menu, de zoeklijst of het inlogvenster open is, of als
  // het zoekveld of de toetsenbordfocus in de kop staat.
  function kopScroll() {
    var sectie = document.querySelector('.shopify-section-header');
    var buiten = document.getElementById('header-outer');
    if (!sectie || !buiten) return;
    var html = document.documentElement;
    var BOVEN = 16;
    var vorige = window.scrollY, omlaag = 0, omhoog = 0, bezig = false, hoogte = 0;
    var meet = function () {
      var r = buiten.getBoundingClientRect(), onder = r.bottom;
      var zoek = document.getElementById('search');
      if (zoek && smal.matches && getComputedStyle(zoek).position === 'absolute') onder = Math.max(onder, zoek.getBoundingClientRect().bottom);
      hoogte = Math.max(40, Math.round(onder - r.top));
      var balkEl = document.getElementById('nav-top');
      sectie.style.setProperty('--bk-balk-h', (balkEl ? balkEl.offsetHeight : 0) + 'px');
      sectie.style.setProperty('--bk-kop-h', (hoogte + 2) + 'px');
    };
    // Open: het menu (van het thema, of het Barlen-menu met de klasse bm-open), de zoeklijst of het inlogvenster, of
    // focus in het zoekveld of toetsenbordfocus in de kop.
    var open = function () {
      var a = document.activeElement;
      var focus = !!a && a !== document.body && sectie.contains(a) && (!!a.closest('#search') || (typeof a.matches === 'function' && a.matches(':focus-visible')));
      return html.classList.contains('m2a') || html.classList.contains('bm-open') || html.classList.contains('search-full') ||
        html.classList.contains('search-compact-active') || html.classList.contains('user-form-active') || focus;
    };
    var zet = function (weg) { if (sectie.classList.contains('bk-kop-weg') !== weg) sectie.classList.toggle('bk-kop-weg', weg); };
    var update = function () {
      bezig = false;
      var y = window.scrollY, d = y - vorige;
      if (d > 0) { omlaag += d; omhoog = 0; } else if (d < 0) { omhoog -= d; omlaag = 0; }
      if (!hoogte) meet();
      if (y < BOVEN || open()) { zet(false); omlaag = 0; omhoog = 0; }
      else if (omlaag > hoogte && !sectie.classList.contains('bk-kop-weg')) { zet(true); omlaag = 0; }
      else if (omhoog > hoogte / 3 && sectie.classList.contains('bk-kop-weg')) { zet(false); omhoog = 0; }
      vorige = y;
    };
    window.addEventListener('scroll', function () { if (!bezig) { bezig = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', meet);
    window.addEventListener('load', meet);
    meet();
    sectie.addEventListener('focusin', function () { zet(false); });
    if (window.MutationObserver) new MutationObserver(function () { if (open()) zet(false); }).observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  function begin() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bk-usp]'), balk);
    zoekveld();
    kopScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin);
  else begin();
})();
